import {ServerModalV3} from "./ServerModalV3";
import {sequentialWordSearch} from "../../search/sequentialWordSearch";
import _ from "lodash";

// noinspection JSUnusedGlobalSymbols -- Imported via d.ts file
/**
 * Class based version of initial modalV2
 */
class TreeModalV3 extends ServerModalV3 {
	/** @var {TreeModalV3Defs.Config} */
	config;

	init() {
		// Init tree
		this.initTreeView();

		// By default call init function from config if set
		if (this.config.init) {
			this.config.init(this);
		}
	}

	initTreeView() {
		// Init Tree View
		this.setupTreeLikeGuides();

		// Init search
		if (this.getSearchInput()) {
			const debouncedSearch = _.debounce(
				() => {
					this.filterRows();
				},
				256,
				{
					trailing: true,
					leading: false,
				}
			)

			this.getSearchInput().addEventListener('keyup', debouncedSearch);
			this.getSearchInput().addEventListener('change', debouncedSearch);
		}
	}

	display(firstTime) {
		super.display(firstTime);

		// Focus search input after modal is displayed
		setTimeout(() => {
			this.focusSearchInput();
		}, 512)
	}

	getSearchInput() {
		return this.modalContainer.querySelector(
			'input[name="search"]'
		);
	}

	focusSearchInput() {
		// Wait a bit and focus search input
		const searchInputElement = this.getSearchInput();

		if (searchInputElement) {
			searchInputElement.focus()
		}
	}

	setupTreeLikeGuides() {
		const modalContainer = this.modalContainer;
		// noinspection DuplicatedCode
		const rows = Array.from(modalContainer.querySelectorAll('tbody tr:not(.d-none)'));

		const indentsMatrix = [];

		rows.forEach(row => {
			indentsMatrix.push(Array.from(row.querySelectorAll('.indent')));
		});

		// Fill tree guides from the bottom up
		for (let x = rows.length - 1; x >= 0; x--) {
			const row = rows[x];
			const depth = parseInt(row.dataset.depth);

			if (depth === 0) {
				// Skip root category
				continue;
			}

			const firstIndent = indentsMatrix[x][depth - 1];
			if (firstIndent) {

				if (firstIndent.classList.contains('guide-middle')) {
					// Replace middle to shared guide
					firstIndent.classList.remove('guide-middle');
					firstIndent.classList.add('guide-middle-shared');
				} else {
					// First of type
					firstIndent.classList.add('guide-end');
					// Also add guide to all indents above

					// Go up from the row trough all the indents
					// noinspection JSSuspiciousNameCombination
					for (let y = x - 1; y >= 0; y--) {

						const indent = indentsMatrix[y] ? indentsMatrix[y][depth - 1] : undefined;
						if (!indent) {
							// Reached the end of the guide
							break;
						}

						indent.classList.add('guide-middle');
					}
				}
			}
		}
	}

	filterRows() {
		// noinspection JSUnresolvedReference
		const searchTerm = this.getSearchInput().value;

		// Clear all rows
		this.modalContainer.querySelectorAll('tr').forEach(row => {
			row.classList.remove('d-none');

			row.classList.remove('matched');

			// Clear all indents
			row.querySelectorAll('.indent').forEach(indent => {
				indent.classList.remove('guide-end');
				indent.classList.remove('guide-middle');
				indent.classList.remove('guide-middle-shared');
			})
		})

		if (searchTerm) {
			// Filter rows
			this.modalContainer.querySelectorAll('tr').forEach(row => {
				if (sequentialWordSearch(row.dataset.filterString, searchTerm, true)) {
					row.classList.add('matched');
				} else {
					if (row.classList.contains('header-entry') === false) {
						// Hide non header entries directly
						row.classList.add('d-none')
					}
				}
			})

			// Now remove non matched, empty categories
			const allRows = Array.from(this.modalContainer.querySelectorAll('tr'));
			allRows.forEach((row, index) => {
				if (
					row.classList.contains('header-entry') &&
					row.classList.contains('matched') === false
				) {
					// noinspection DuplicatedCode
					const categoryDepth = parseInt(row.dataset.depth);

					// Check if it has no matched children
					let hasMatchedChildren = false;

					for (let x = index + 1; x < allRows.length; x++) {
						const nextRow = allRows[x];
						// Check if row is a children
						const nextRowDepth = parseInt(nextRow.dataset.depth);

						if (nextRowDepth > categoryDepth) {
							// Row is a child of category, check if matched
							if (nextRow.classList.contains('matched')) {
								hasMatchedChildren = true;
								// Found a match in children, stop looking for matches
								break;
							}
						} else {
							// No more children, stop looking for matches
							break;
						}
					}

					if (hasMatchedChildren === false) {
						// Hide category
						row.classList.add('d-none');
					}
				}
			})
		}

		this.setupTreeLikeGuides();
	}
}

export {TreeModalV3}
